import { GetterTree } from 'vuex'
import { UiContentModalState } from './state'

const getters: GetterTree<UiContentModalState, UiContentModalState> = {
  modal: ({ modal }) => modal,
  modalVisible: ({ visible }) => visible,
}

export default getters
